import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import webinarBanner from "../assets/WEBINAR-RPA-banner.jpg";

import { useEffect } from "react";
import {
  FaRobot,
  FaVideo,
  FaCog,
  FaBullhorn,
  FaShoppingCart,
  FaWifi,
  FaTv,
  FaHeartbeat,
  FaUniversity,
  FaIndustry,
  FaBook,
  FaUsers,
  FaLeaf,
  FaFileAlt,
  FaCube,
  FaStore
} from "react-icons/fa";
import { MdFindInPage } from "react-icons/md";
import { FiSearch } from "react-icons/fi";

import { AiOutlineRight } from "react-icons/ai";

import aiBanner from "../assets/ai_banner.png";
import aiIllustration from "../assets/ai-illustration.png";
import consultingIcon from "../assets/ai (1).png";
import dataIcon from "../assets/2721494.png";
import voiceIcon from "../assets/1230996.png";
import imageIcon from "../assets/181200.png";
import chatbotIcon from "../assets/chatbot-icon.png";
import testingIcon from "../assets/2562004.png";
import staffIcon from "../assets/outstaff.png";

const styles = `
  /* ── TABS ── */
  .ai-tabs-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 18px;
  }

  .ai-tab-item {
    background: rgba(48,128,120,0.28);
    border: 1px solid rgba(0,0,0,0.10);
    height: 58px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
  }

  .ai-tab-label {
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    font-family: Exo, sans-serif;
    white-space: nowrap;
  }

  /* ── CORE SECTION ── */
  .ai-core-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 60px 80px;
    background: #efefef;
    gap: 50px;
  }

  .ai-core-img {
    max-width: 600px;
    object-fit: contain;
    margin-left: -60px;
    margin-top: 20px;
    flex-shrink: 0;
  }

  .ai-core-text {
    max-width: 600px;
  }

  /* ── DIFFERENTIATORS ── */
  .ai-diff-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
  }

  /* ── SERVICES ── */
  .ai-services-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  /* ── TECHNOLOGIES ── */
  .ai-tech-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
  }

  /* ── CASE STUDIES ── */
  .ai-cases-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
  }

  /* ── USE CASES ── */
  .ai-usecases-grid {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 18px;
  }

  /* ── VIDEOS ── */
  .ai-videos-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(80px, 1fr));
    gap: 26px;
  }

  /* ── TABLET (max-width: 1024px) ── */
  @media (max-width: 1024px) {
    .ai-tabs-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;
    }

    .ai-tab-label {
      font-size: 15px;
    }

    .ai-core-section {
      padding: 40px 40px;
      gap: 30px;
    }

    .ai-core-img {
      max-width: 420px;
      margin-left: 0;
    }

    .ai-diff-grid {
      grid-template-columns: repeat(2, 1fr);
    }

    .ai-services-grid {
      grid-template-columns: repeat(2, 1fr);
    }

    .ai-tech-grid {
      grid-template-columns: repeat(2, 1fr);
    }

    .ai-cases-grid {
      grid-template-columns: repeat(2, 1fr);
    }

    .ai-usecases-grid {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .ai-videos-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  /* ── SMALL TABLET / LANDSCAPE MOBILE (max-width: 768px) ── */
  @media (max-width: 768px) {
    .ai-tabs-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;
    }

    .ai-tab-item {
      height: auto;
      padding: 10px 12px;
    }

    .ai-tab-label {
      font-size: 13px;
      white-space: normal;
    }

    .ai-core-section {
      flex-direction: column;
      padding: 30px 20px;
      gap: 20px;
      text-align: center;
    }

    .ai-core-img {
      max-width: 100%;
      width: 100%;
      margin-left: 0;
      margin-top: 0;
    }

    .ai-core-text {
      max-width: 100%;
    }

    .ai-diff-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;
    }

    .ai-services-grid {
      grid-template-columns: 1fr;
    }

    .ai-tech-grid {
      grid-template-columns: 1fr;
    }

    .ai-cases-grid {
      grid-template-columns: 1fr;
    }

    .ai-usecases-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .ai-videos-grid {
      grid-template-columns: 1fr;
    }
  }

  /* ── PORTRAIT MOBILE (max-width: 480px) ── */
  @media (max-width: 480px) {
    .ai-tabs-grid {
      grid-template-columns: 1fr;
      gap: 8px;
    }

    .ai-tab-item {
      height: auto;
      padding: 10px 14px;
    }

    .ai-tab-label {
      font-size: 14px;
    }

    .ai-core-section {
      padding: 24px 14px;
    }

    .ai-diff-grid {
      grid-template-columns: 1fr;
    }

    .ai-usecases-grid {
      grid-template-columns: 1fr;
    }
  }
`;

function AIPage() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const el = document.getElementById(location.state.scrollTo);

      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 200);
      }
    }
  }, [location]);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);

    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  const tabs = [
    {
      label: "AI Services",
      icon: <FaRobot />,
      id: "services"
    },
    {
      label: "AI Use Cases",
      icon: <FaCube />,
      id: "usecases"
    },
    {
      label: "Case Studies",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M14 2H7C6.45 2 6 2.45 6 3V21C6 21.55 6.45 22 7 22H17C17.55 22 18 21.55 18 21V6L14 2Z"
            stroke="white"
            strokeWidth="2"
          />
          <path d="M14 2V6H18" stroke="white" strokeWidth="2" />
          <path d="M9 10H15" stroke="white" strokeWidth="1.5" />
          <path d="M9 13H13" stroke="white" strokeWidth="1.5" />
          <circle cx="15.5" cy="14.5" r="3.5" stroke="white" strokeWidth="1.5" />
          <path d="M18 17L21 20" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      ),
      id: "casestudies"
    },
    {
      label: "Demo Videos",
      icon: <FaVideo />,
      id: "videos"
    }
  ];

  const useCases = [
    { icon: <FaCog />, label: "Operations", link: "/operations" },
    { icon: <FaBullhorn />, label: "Marketing", link: "/marketing" },
    { icon: <FaShoppingCart />, label: "Sales", link: "/sales" },
    { icon: <FaWifi />, label: "Telecommunication", link: "/telecom" },
    { icon: <FaTv />, label: "Entertainment", link: "/entertainment" },
    { icon: <FaHeartbeat />, label: "Healthcare", link: "/healthcare" },
    { icon: <FaUniversity />, label: "Banking and Finance", link: "/banking" },
    { icon: <FaIndustry />, label: "Manufacturing", link: "/manufacturing" },
    { icon: <FaBook />, label: "Education", link: "/education" },
    { icon: <FaUsers />, label: "Customer Service", link: "/customer" },
    { icon: <FaLeaf />, label: "Agriculture", link: "/agriculture" },
    { icon: <FaFileAlt />, label: "Insurance", link: "/insurance" },
    { icon: <FaStore />, label: "Retail", link: "/retail" }
  ];

  const services = [
    {
      title: "AI Consulting",
      icon: consultingIcon,
      points: ["Technical Evaluation", "Develop strategy & Road map"]
    },
    {
      title: "AI / ML Services (Data Analytics)",
      icon: dataIcon,
      points: [
        "Machine Learning",
        "Deep Learning",
        "Data Mining",
        "Predictive Analytics",
        "Sentiment Analysis",
        "Anomaly Detection",
        "Statistical Modeling Visualization"
      ]
    },
    {
      title: "Voice Analytics",
      icon: voiceIcon,
      points: ["Speech Recognition", "Voice to text", "Voice analysis"]
    },
    {
      title: "Image Analytics",
      icon: imageIcon,
      points: [
        "Image Tagging",
        "Optical Character Recognition",
        "Face / Object Detection",
        "Object Tracking",
        "Image processing"
      ]
    },
    {
      title: "Intelligent Chatbots",
      icon: chatbotIcon,
      points: [
        "Customer/Technical Support chatbots",
        "AI chatbots",
        "Conversational Chatbots",
        "Voice chatbots"
      ]
    },
    {
      title: "AI / ML Testing",
      icon: testingIcon,
      points: ["Testing Plan", "Test cases development", "Test execution", "Reporting"]
    },
    {
      title: "AI/ML Staff outsourcing",
      icon: staffIcon,
      points: [
        "Expert AI/ML/CV/NLP/Python developers as per the requirement",
        "Short term & Long term skilled resource deployment"
      ]
    }
  ];

  const technologies = [
    ["django", "open source", "python", "OpenCv", "TensorFlow", "Keras", "PyTorch", "Dialogflow"],
    ["JavaScript", "nodejs", "Angularjs", "Microsoft CNTK", "Flask", "APACHE Spark", "hadoop", "Java"],
    ["Matlab", "php", "Microsoft Visual Studio", "Microsoft SQL Server", "Azure", "AWS", "Google Cloud Platform", "Docker", "Gradle"]
  ];

  const caseStudies = [
    {
      title: "Identify Regulations and monitor compliance as per Law",
      description:
        "This ML based solution extracts state & federal regulations. Validates whether companies are complying to these regulations when ever there are new laws.",
      domain: "Compliance & Regulations | NLP, MySQL, Text mining.",
      customer: "Attorney consulting firm specialized in Cannabis & Cyber security.",
      region: "United States of America"
    },
    {
      title: "Nonperforming assets (NPA's) - Anomaly detection",
      description:
        "This solutions validates the customer financial data & identify NPA's and gives score to each customer as standard, doubtful1,2,3 type. Helps financial org from incurring losses.",
      domain: "Banking & Finance | Data visualization Techniques, Data Analysis.",
      customer: "Non banking financial company(NBFC) providing consulting services",
      region: "APAC region"
    },
    {
      title: "Virtual Assistant to Doctor",
      description:
        "This chatbot helps hospital to pre-screen the patient to reduce the doctor's efforts. This chatbot also perform admin tasks like booking appointment, insurance claims etc.,",
      domain: "Healthcare | NLP, LSTM, GRU, Keras models, Django",
      customer: "A hospital in India provide multiple specialized services",
      region: "India"
    },
    {
      title: "Toll fee validation based on vehicle type",
      description:
        "This deep learning solution validates the approaching vehicle at toll gates, capture & read the vehicle number, model & make. By using the algorithm identifies the type of vehicle and appropriate toll fee will be collected",
      domain: "Roads & Transportation | Image processing, Open CV, DNN,",
      customer: "A construction company operates toll road.",
      region: "APAC"
    },
    {
      title: "Product Recommendation System",
      description:
        "This model analyses customer profile, history, on screen navigations and display the appropriate products",
      domain: "eCommerce | Content and Collaborative Based Filtering, Semantic Analysis, KNN.",
      customer: "Online gift seller by using web application.",
      region: "Europe"
    }
  ];

  const videos = [
    { id: "6eGTt4EDRYg", title: "Artificial Intelligence (AI) Use Cases for Healthcare" },
    { id: "QAP2gUTm6ds", title: "AI used cases in finance" },
    { id: "8xqo5iPSHjA", title: "How Artificial Intelligence (AI) is used in Biotechnology - Use cases" },
    { id: "1jHHbCzzCQ0", title: "AI Based - Fraud Identification & NPA Analysis" },
    { id: "q_gngcv9L_c", title: "AI Chatbot for Real Estate - Virtual Sales Executive" },
    { id: "P-ePUw4Y8m4", title: "Automated Invoice (PDF/Image) Processing Using Open Source RPA / AI Bots" },
    { id: "dz577lk_D2E", title: "Virtual Assistant to the Doctor | AI Based Pre-screening" },
    { id: "Zil8I4um6-M", title: "Face mask detection & tracking in crowd" },
    { id: "p7W5yFYle9k", title: "Chat-bot Types ( AI Based | Command based | Whats App | Skype | Command)" },
    { id: "bNnXIE1S7w0", title: "Face mask identification" }
  ];

  return (
    <div>
      <style>{styles}</style>

      {/* HERO SECTION */}
      <div style={{ width: "100%", background: "#2fb7a4" }}>
        <img
          src={aiBanner}
          alt="AI Banner"
          style={{ width: "100%", display: "block" }}
        />
      </div>

      {/* TOP TABS */}
      <div
        style={{
          backgroundImage: `linear-gradient(rgba(43,190,174,0.78), rgba(43,190,174,0.78)), url(${webinarBanner})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          padding: "20px 18px"
        }}
      >
        <div className="ai-tabs-grid">
          {tabs.map((tab, i) => (
            <div
              key={i}
              className="ai-tab-item"
              onClick={() => scrollToSection(tab.id)}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <div
                  style={{
                    width: "35px",
                    height: "35px",
                    background: "rgba(0,0,0,0.18)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "8px",
                    color: "#fff",
                    flexShrink: 0
                  }}
                >
                  {React.cloneElement(tab.icon, { size: 20 })}
                </div>

                <span className="ai-tab-label">{tab.label}</span>
              </div>

              <AiOutlineRight size={15} style={{ color: "#fff", flexShrink: 0 }} />
            </div>
          ))}
        </div>
      </div>

      {/* CORE SECTION */}
      <div className="ai-core-section">
        <img
          src={aiIllustration}
          alt="Artificial Intelligence"
          className="ai-core-img"
        />

        <div className="ai-core-text">
          <p
            style={{
              fontSize: "14px",
              color: "#3976c9",
              fontWeight: "680",
              fontFamily: "Exo, sans-serif",
              marginBottom: "25px"
            }}
          >
            Core Services Portfolio
          </p>

          <h1
            style={{
              fontSize: "40px",
              fontWeight: "700",
              lineHeight: "1.1",
              fontFamily: "Exo, sans-serif",
              color: "#2B2B2B",
              marginBottom: "25px"
            }}
          >
            Artificial Intelligence
          </h1>

          <p style={{ lineHeight: "1.6", fontSize: "15px" }}>
            Artificial intelligence (AI) is a wide-ranging branch of computer science
            concerned with building smart machines capable of performing tasks
            that typically require human intelligence.
          </p>

          <ul style={{ lineHeight: "1.8", fontSize: "15px", paddingLeft: "24px" }}>
            <li>Reactive Machines</li>
            <li>Limited Memory</li>
            <li>Theory of Mind</li>
            <li>Self-Awareness</li>
          </ul>
        </div>
      </div>

      {/* DIFFERENTIATORS */}
      <div
        style={{
          background: "#264785",
          padding: "22px 16px 60px",
          overflow: "hidden"
        }}
      >
        <h1
          style={{
            textAlign: "center",
            color: "#fff",
            fontSize: "46px",
            fontWeight: "700",
            marginBottom: "36px",
            fontFamily: "Exo, sans-serif",
            lineHeight: "1"
          }}
        >
          AI Differentiators
        </h1>

        <div className="ai-diff-grid">
          {[
            ["30+", "Customers"],
            ["Skills", "High Skilled Professionals"],
            ["High Quality", "Independent AI testing team"],
            ["Focus", "High Executive Focus"],
            ["Software's", "Open Source & Commercial software"],
            ["Centre of Excellence", "R & D , Assets, Knowledge Base"]
          ].map((item, i) => (
            <div
              key={i}
              style={{
                border: "2px solid rgba(255,255,255,0.9)",
                borderRadius: "8px",
                height: "120px",
                padding: "6px 6px",
                background: "transparent",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
              }}
            >
              <h2
                style={{
                  color: "#fff",
                  fontSize: "24px",
                  fontWeight: "700",
                  margin: "0 0 26px",
                  lineHeight: "1",
                  fontFamily: "Exo, sans-serif"
                }}
              >
                {item[0]}
              </h2>

              <p
                style={{
                  color: "#1fe0c4",
                  fontSize: "13px",
                  lineHeight: "1.55",
                  fontWeight: "600",
                  margin: 0,
                  maxWidth: "90%",
                  fontFamily: "Exo, sans-serif"
                }}
              >
                {item[1]}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* SERVICES */}
      <div
        id="services"
        style={{
          background: "#efefef",
          padding: "50px 24px 70px"
        }}
      >
        <h1
          style={{
            textAlign: "center",
            fontSize: "46px",
            fontWeight: "700",
            marginBottom: "38px",
            fontFamily: "Exo, sans-serif",
            color: "#111",
            lineHeight: "1"
          }}
        >
          AI Services
        </h1>

        <div className="ai-services-grid">
          {services.map((service, i) => (
            <div
              key={i}
              style={{
                background: "#efefef",
                border: "2px solid #4b84d9",
                borderRadius: "10px",
                padding: "7px 10px 15px",
                minHeight: "70px",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden"
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "120px",
                  marginBottom: "15px"
                }}
              >
                <img
                  src={service.icon}
                  alt={service.title}
                  style={{ width: "120px", height: "120px", objectFit: "contain" }}
                />
              </div>

              <h2
                style={{
                  fontSize: "28px",
                  fontWeight: "700",
                  marginBottom: "25px",
                  fontFamily: "Exo, sans-serif",
                  color: "#111",
                  lineHeight: "1.15",
                  textAlign: "center",
                  whiteSpace: "pre-line"
                }}
              >
                {service.title}
              </h2>

              <ul style={{ paddingLeft: "30px", margin: 0, marginTop: "10px" }}>
                {service.points.map((point, index) => (
                  <li
                    key={index}
                    style={{
                      fontSize: "16px",
                      lineHeight: "2",
                      color: "#111",
                      fontWeight: "400",
                      marginBottom: "2px",
                      fontFamily: "Arial, sans-serif"
                    }}
                  >
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* TECHNOLOGIES */}
      <div style={{ background: "#264785", padding: "55px 30px 60px" }}>
        <h1
          style={{
            textAlign: "center",
            fontSize: "46px",
            fontWeight: "700",
            color: "#fff",
            lineHeight: "1",
            fontFamily: "Exo, sans-serif",
            marginBottom: "42px"
          }}
        >
          Artificial Intelligence, Machine <br />Learning & Chatbots
        </h1>

        <div className="ai-tech-grid">
          {technologies.map((column, i) => (
            <div
              key={i}
              style={{
                border: "2px solid rgba(255,255,255,0.9)",
                borderRadius: "8px",
                minHeight: "170px",
                padding: "20px 30px",
                boxSizing: "border-box"
              }}
            >
              <ul style={{ paddingLeft: "24px", margin: 0 }}>
                {column.map((item, index) => (
                  <li
                    key={index}
                    style={{
                      color: "#fff",
                      fontSize: "15px",
                      lineHeight: "1.6",
                      marginBottom: "2px",
                      fontFamily: "Arial"
                    }}
                  >
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* CASE STUDIES */}
      <div
        id="casestudies"
        style={{
          background: "#efefef",
          padding: "10px 10px"
        }}
      >
        <h1
          style={{
            textAlign: "center",
            fontSize: "46px",
            marginBottom: "50px",
            fontFamily: "Exo, sans-serif"
          }}
        >
          Case Studies
        </h1>

        <div className="ai-cases-grid">
          {caseStudies.map((study, i) => (
            <div
              key={i}
              style={{
                background: "#3147a5",
                color: "#fff",
                padding: "35px",
                borderRadius: "10px",
                lineHeight: "1.8",
                minHeight: "360px"
              }}
            >
              <h3
                style={{
                  color: "#1fe0c4",
                  textAlign: "center",
                  fontSize: "24px",
                  lineHeight: "1.2",
                  fontFamily: "Exo, sans-serif",
                  marginTop: 0
                }}
              >
                {study.title}
              </h3>

              <p><b>Description:-</b> {study.description}</p>
              <p>- {study.domain}</p>
              <p><b>Customer:</b> {study.customer}</p>
              <p><b>Region:</b> {study.region}</p>
            </div>
          ))}
        </div>
      </div>

      {/* USE CASES */}
      <div
        id="usecases"
        style={{
          background: "linear-gradient(180deg,#2fb7a4,#1c3f7b)",
          padding: "55px 30px 70px"
        }}
      >
        <h1
          style={{
            textAlign: "center",
            color: "#fff",
            fontSize: "46px",
            fontWeight: "700",
            marginBottom: "42px",
            fontFamily: "Exo, sans-serif",
            lineHeight: "1"
          }}
        >
          Artificial Intelligence Use Cases
        </h1>

        <div className="ai-usecases-grid">
          {useCases.map((item, i) => (
            <div
              key={i}
              onClick={() => item.link && navigate(item.link)}
              style={{
                background: "rgba(0,0,0,0.18)",
                borderRadius: "10px",
                height: "72px",
                padding: "0 12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                boxSizing: "border-box",
                cursor: "pointer",
                transition: "0.3s ease"
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "14px",
                  width: "100%"
                }}
              >
                <div
                  style={{
                    width: "38px",
                    height: "38px",
                    background: "rgba(0,0,0,0.22)",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    color: "#fff",
                    fontSize: "16px"
                  }}
                >
                  {React.cloneElement(item.icon, { size: 18 })}
                </div>

                <span
                  style={{
                    color: "#fff",
                    fontSize: "15px",
                    fontWeight: "500",
                    fontFamily: "Exo, sans-serif",
                    lineHeight: "1.3"
                  }}
                >
                  {item.label}
                </span>
              </div>

              <AiOutlineRight size={14} style={{ color: "#fff", flexShrink: 0 }} />
            </div>
          ))}
        </div>
      </div>

      {/* VIDEOS */}
      <div
        id="videos"
        style={{
          background: "#efefef",
          padding: "55px 40px"
        }}
      >
        <h1
          style={{
            textAlign: "center",
            fontSize: "46px",
            marginBottom: "45px",
            fontFamily: "Exo, sans-serif",
            fontWeight: "700",
            color: "#111"
          }}
        >
          Demo Videos
        </h1>

        <div className="ai-videos-grid">
          {videos.map((video, i) => (
            <div
              key={i}
              style={{
                border: "2px solid #4b84d9",
                borderRadius: "10px",
                background: "#efefef",
                padding: "18px 18px 12px",
                minHeight: "150px"
              }}
            >
              <h3
                style={{
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                  color: "#111",
                  lineHeight: "1.15",
                  marginBottom: "18px",
                  fontFamily: "Exo, sans-serif",
                  minHeight: "58px"
                }}
              >
                {video.title}
              </h3>

              <div
                style={{
                  width: "100%",
                  overflow: "hidden",
                  borderRadius: "4px"
                }}
              >
                <iframe
                  src={`https://www.youtube.com/embed/${video.id}`}
                  title={video.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{
                    width: "100%",
                    height: "230px",
                    border: "none",
                    display: "block"
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AIPage;
